// extracted by mini-css-extract-plugin
export default {"invoiceActions":"open-status_invoiceActions__DPt2L"};